<!-- user-list.component.html -->

<div class="container-fluid">
    <div class="row">
        <div class="col-lg-11">
            <div class="card">
                <div class="card-body">
                    <div *ngIf="showTable; else formView">
                        <div class="row">
                            <div class="col-md-12">
                                <h3 class="text-center font-bold font-up danger-text">Orders To Make Ticket - Kindly SAVE</h3>
                                
                                <div class="row justify-content-center mt-3">
                                    <!-- <div class="col-md-2">
                                        <label for="statusFilter">Filter by Status:</label>
                                        <select id="statusFilter" [(ngModel)]="selectedStatus" (change)="filterOrders()" class="form-control">
                                            <option value="">All Orders</option>
                                            <option value="MatProcessAllocated">New Orders</option>
                                            <option value="Repeated Order">Repeat Orders</option>
                                        </select>
                                    </div> -->
                                    <div class="col-md-2">
                                        <label for="fromDate">From:</label>
                                        <input type="date" id="fromDate" [(ngModel)]="fromDate" (change)="filterOrders()" class="form-control" />
                                    </div>
                                    <div class="col-md-2">
                                        <label for="toDate">To:</label>
                                        <input type="date" id="toDate" [(ngModel)]="toDate" (change)="filterOrders()" class="form-control" />
                                    </div>
                                    <div class="col-md-2">
                                        <label for="clientName">Client Name:</label>
                                        <input type="text" id="clientName" placeholder="Client Name" [(ngModel)]="clientName" (input)="filterOrders()" class="form-control" />
                                    </div>
                                    <div class="col-md-2">
                                        <label for="refNo">Reference No:</label>
                                        <input type="text" id="refNo" placeholder="Reference No" [(ngModel)]="refNo" (input)="filterOrders()" class="form-control" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                          
                      
                        <button (click)="deleteSelectedEntries()" class="btn btn-outline-danger mb-3"><i class="feather icon-trash-2"></i></button>
                        <div class="table-responsive">
                            <table class="table mb-0 table-centered table-bordered">
                                <thead>
                                    <tr>
                                        <th><input type="checkbox" id="selectAllCheckbox" (change)="selectAllChanged($event)"></th>
                                        <th>Ticket No</th>
                                        <th>Ref No</th>
                                        <th>PO No</th>
                                        <th>Client Name</th>
                                        <th>Job Name</th>
                                        <th>Job Type</th>
                                        <th>Order Kgs</th>

                                        <th>Status</th>

                                    </tr>
                                </thead>

                                <!-- Add *ngFor loop for displaying user data -->
                                <tbody>
                                    <tr *ngFor="let order of orderList">
                                        <td><input type="checkbox" class="rowCheckbox" [attr.data-id]="order._id"></td>
                                        <td>{{ order.ticketno }}</td>
                                        <td>{{ order.refNo }}</td>
                                        <td>{{ order.poNo||
                                            order.poNum
                                             }}</td>
                                        <td>{{ order.clientName}}</td>
                                        <td>{{ order.jobName }}</td>
                                        <td>{{ order.jobType }}</td>
                                        <td>{{ order.orderKgs || order.orderQty }}</td>
                                        <td>
                                            <button type="button" class="btn btn-outline-success btn-sm"
                                                (click)="saveOrder()" [routerLink]="['/UnsavedOrder', order._id]" title="Click to Generate Ticket">
                                                <i class="feather ticket "></i>Generate Ticket
                                            </button>


                                        </td>
                                    </tr>
                                </tbody>
                            </table><!--end /table (click)="saveOrder()"  routerLink="/UnsavedOrder/{{order._id}}" -->
                        </div><!--end /tableresponsive-->

                        <div class="pagination-container">
                            <div class="pagination mt-3 d-flex justify-content-between align-items-center">
                                <div>
                                    <p>Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ totalItems
                                        }}</p>
                                </div>
                                <div class="pagination mt-3 d-flex justify-content-center">
                                    <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)"
                                        [ngClass]="{'disabled': currentPage === 1}">
                                        <i class="feather icon-chevrons-left"></i>
                                    </a>
                                    <a *ngFor="let page of getPages()" class="pagination-circle"
                                        [class.active]="currentPage === page" (click)="onPageChange(page)">{{ page }}</a>
                                    <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)"
                                        [ngClass]="{'disabled': currentPage === mathLib.ceil(totalItems / itemsPerPage)}">
                                        <i class="feather icon-chevrons-right "></i>
                                    </a>
                                </div>
                                <!-- <div class="d-flex">
                                    <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)"
                                        [ngClass]="{'disabled': currentPage === 1}">
                                        <i class="feather icon-chevrons-left"></i>
                                    </a>

                                    <ng-container *ngFor="let page of getNumberRange(ceil(totalItems / itemsPerPage))">
                                        <a class="pagination-circle" [class.active]="currentPage === page"
                                            (click)="onPageChange(page)">
                                            {{ page }}
                                        </a>
                                        <span *ngIf="page < ceil(totalItems / itemsPerPage)"
                                            class="page-number-space"></span>
                                    </ng-container>

                                    <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)"
                                        [ngClass]="{'disabled': currentPage === ceil(totalItems / itemsPerPage)}">
                                        <i class="feather icon-chevrons-right"></i>
                                    </a>
                                </div> -->

                            </div>
                        </div>
                    </div>
                    <ng-template #formView>
                        <div class="mb-4 d-md-flex align-items-center justify-content-between">

                            <div>
                                <h3>Complete Job info and Save</h3>
                                <p>Kindly check all the information and correct all mistakes and update, then save</p>
                            </div>
                        </div>
                        <div class="form-card">
                            <form (ngSubmit)="submitForm()" [formGroup]="unsavedOrderForm">
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="jssId" class="form-label">Jss Id</label>
                                        <input type="text" formControlName="jssId" id="jssId"
                                            class="form-control" readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="clientName" class="form-label">Client Name</label>
                                        <input type="text" formControlName="clientName" id="clientName"
                                            class="form-control" readonly />
                                    </div>

                                    <div class="col form-group mb-3">
                                        <label for="ticketno" class="form-label">Ticket No.</label>
                                        <input type="text" formControlName="ticketno" id="ticketno" class="form-control"
                                            readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="jssfolderno" class="form-label">JSS Folder No.</label>
                                        <input type="text" formControlName="jssfolderno" id="jssfolderno"
                                            class="form-control"  readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="poNo" class="form-label">P.O No.</label>
                                        <input type="text" formControlName="poNo" id="poNo" class="form-control"
                                            readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="refNo" class="form-label">Ref No.</label>
                                        <input type="text" formControlName="refNo" id="refNo" class="form-control"
                                            readonly />
                                    </div>
                                </div>
                                <div class="row">


                                    <div class="col form-group mb-3">
                                        <label for="jobName" class="form-label">Job Name</label>
                                        <input type="text" formControlName="jobName" id="jobName" class="form-control"
                                            readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="jobType" class="form-label">Job Type</label>
                                        <input type="text" formControlName="jobType" id="jobType" class="form-control"
                                            readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="orderKgs" class="form-label">Order Qty</label>
                                        <input type="text" formControlName="orderKgs" id="orderKgs" class="form-control"
                                            readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="LamType" class="form-label">Lam Type</label>
                                        <input type="text" formControlName="LamType" id="LamType" class="form-control"
                                            readonly />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="location" class="form-label">Cyinder Location</label>
                                        <input type="text" formControlName="location" id="location"
                                            class="form-control" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label class="form-label" for="length">Face Length</label>
                                        <input type="text" formControlName="length" id="length" class="form-control" readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label class="form-label" for="circumference" >Cylinder Circumference</label>
                                        <input type="text" formControlName="circumference"
                                            id="circumference" class="form-control" readonly/>
                                    </div>
                                </div>
                                <!-- <div class="row">
                                    <div class="form-group mb-3" *ngFor="let process of materialProcesses; let i = index">
                                      <label class="form-label">Process {{ i + 1 }}</label>
                                      <div class="d-flex">
                                        <input type="text" [formControlName]="'processType' + (i + 1)" id="'processType' + (i + 1)"
                                               class="form-control mr-2" placeholder="Process" />
                                        <input type="text" [formControlName]="'material' + (i + 1)" id="'material' + (i + 1)"
                                               class="form-control mr-2" placeholder="Material" />
                                        <input type="text" [formControlName]="'matSize' + (i + 1)" id="'matSize' + (i + 1)"
                                               class="form-control mr-2" placeholder="matSize" />
                                        <input type="text" [formControlName]="'matReq' + (i + 1)" id="'matReq' + (i + 1)"
                                               class="form-control mr-2" placeholder="Mat Size" />
                                      </div>
                                    </div>
                                  </div> -->
                                  
                                <div class="row">
                                    <div class="form-group mb-3" *ngFor="let index of [1, 2, 3, 4, 5, 6]; let i = index">
                                        <div class="d-flex">
                                        <div class="col form-group">
                                            <label class="form-label">Process {{ i + 1 }}</label>
                                            <input type="text" [formControlName]="'Process' + (i + 1)" id="'Process' + (i + 1)"
                                                class="form-control mr-2" placeholder="Process" />
                                        </div>
                                        <div class="col form-group">
                                        <label class="form-label">Material {{ i + 1 }}</label>
                                            
                                            <input type="text" [formControlName]="'material' + (i + 1)" id="'material' + (i + 1)"
                                                class="form-control mr-2" placeholder="Material" />
                                        </div>
                                        <div class="col form-group">
                                        <label class="form-label">Mat Size( Width) {{ i + 1 }}</label>
                                            <input type="text" [formControlName]="'matSize' + (i + 1)" id="'matSize' + (i + 1)"
                                                class="form-control mr-2" placeholder="Width" />
                                        </div>
                                        <div class="col form-group">
                                            <label class="form-label">Thickness {{ i + 1 }}</label>
                                                <input type="text" [formControlName]="'thickness' + (i + 1)" id="'thickness' + (i + 1)"
                                                    class="form-control mr-2" placeholder="Thickness" />
                                            </div>
                                        <div class="col form-group">
                                        <label class="form-label">Matreq {{ i + 1 }}</label>
                                            <input type="text" [formControlName]="'matReq' + (i + 1)" id="'matReq' + (i + 1)"
                                                class="form-control mr-2" placeholder="0" />
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="std" class="form-label">STD. INK GSM</label>
                                            <input type="text" formControlName="std" id="std"
                                                class="form-control" readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="liquid" class="form-label">Liquid Ink</label>
                                            <input type="text" formControlName="liquid" id="liquid" class="form-control" readonly/>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="inkType" class="form-label">Ink Type</label>
                                            <input type="text" formControlName="inkType" id="inkType"
                                                class="form-control" readonly/>

                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="printType" class="form-label">Print Type</label>
                                            <input type="text" formControlName="printType" id="printType" class="form-control" readonly/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="printDirection" class="form-label">Print Direction</label>
                                            <input type="text" formControlName="printDirection" id="printDirection" class="form-control" readonly/>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="colorNumber" class="form-label">No. of Colors</label>
                                        <input type="text" formControlName="colorNumber" id="colorNumber" class="form-control" readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="colorNames" class="form-label">Color Names</label>
                                        <input type="text" formControlName="colorNames" id="colorNames" class="form-control" readonly/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="coilWidth" class="form-label">Coil Width</label>
                                        <input type="text" formControlName="coilWidth" id="coilWidth"
                                            class="form-control" readonly/>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="coilod" class="form-label">Coil OD</label>
                                        <input type="text" formControlName="coilod" id="coilod" class="form-control" readonly/>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="fdOption" class="form-label">Final Direction</label>
                                        <input type="text" formControlName="fdOption" id="fdOption"
                                            class="form-control" readonly />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="packageType" class="form-label">Packaging Type</label>
                                        <input type="text" formControlName="packageType" id="packageType"
                                            class="form-control" readonly/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="pouch" class="form-label">Pouch</label>
                                        <input type="text" formControlName="pouch" id="pouch" class="form-control" readonly/>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="remark" class="form-label">Remarks</label>
                                        <input type="text" formControlName="remark" id="remark" class="form-control" readonly/>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="date" class="form-label">Delivery Date</label>
                                        <input type="date" formControlName="date1" id="date1" class="form-control" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="created" class="form-label">Order Date</label>
                                        <input type="text" formControlName="created" id="created" class="form-control"
                                            readonly />
                                    </div>


                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3 mt-20">
                                        <label for="gluing" class="form-label">Gluing Rolls</label>

                                        <input type="text" formControlName="gluing" id="gluing" class="form-control"
                                            placeholder="0" />
                                    </div>
                                 

                                    <div class="col form-group">
                                            <label for="adhesive" class="form-label form-label-a">Adhesive</label>

                                            <div class=" row d-flex">
                                                <div class="col form-group">
                                                    <label class="form-label form-label-a">NCO</label>
                                                    <input type="text" formControlName="nco" id="nco" class="form-control"
                                                        placeholder="NCO" />
                                                </div>
                                                <div class="col form-group ">
                                                    <label class="form-label form-label-a">OH</label>
                                                    <input type="text" formControlName="oh" id="oh"
                                                        class="form-control" placeholder="OH" />
                                                </div>
                                            </div>
                                        

                                    </div>
                                    <!-- <div class="col form-group mb-3">
                                        <label for="rollsWidth" class="form-label">Rolls Width </label>
                                        <input type="text" formControlName="rollsWidth" id="rollsWidth"
                                            class="form-control" />
                                    </div> -->
                                    <div class="col form-group mb-3 mt-20">
                                        <label for="cutting" class="form-label">Cutting Size</label>
                                        <input type="text" formControlName="cutting" id="cutting"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="prepared" class="form-label">Prepared by</label>
                                        <input type="text" formControlName="prepared" id="prepared"
                                            class="form-control" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="approved" class="form-label">Approved by</label>
                                        <input type="text" formControlName="approved" id="approved"
                                            class="form-control" />
                                    </div>

                                </div>
                                <button type="submit" class="btn btn-outline-dark">Save Ticket</button>
                            </form>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>